enum ProfileStoreType {
  MAP,
  PROFILE,
  TABLE,
  FORM,
  SECTION,
}

enum SketchState {
  INIT,
  START,
  ACTIVE,
  COMPLETE,
  CANCEL,
}

enum ProfileKeyCode {
  DEFAULT,
  IA, // Independent Alignment
  CSO, // Cross Section Original
  CSD, // Cross Section Designed
  WCL, // Waterway Centerline
  WLB, // Waterway Low Bank
  WRB, // Waterway Right Bank
  WLTB, // Waterway Left Bank
  REACH, // Reach
  WTL, // WaterLevel
  TGS, // Terrace Ground Surface
}

export type DynamicProfileLayerType = 'curved alignment' | 'primary alignment' | 'cross section';

export { ProfileStoreType, SketchState, ProfileKeyCode };
